import { GetAbilitiesData } from '../../../modules/users/ability.types';
import { restApi } from '../../api';
import { FindTeamsParams, GetTeamOutput, GetTeamsOutput } from './users.types';

const PATH = 'users';

export const getTeam = () => restApi.get<GetTeamOutput>(`${PATH}/team/v1`);

export const findTeams = (params: FindTeamsParams) =>
  restApi.get<GetTeamsOutput>(`${PATH}/teams/v1`, params);

export const findAdminUserTeams = (userId: string, params: FindTeamsParams) =>
  restApi.get<GetTeamsOutput>(`admin/${PATH}/${userId}/teams`, params);

export const getAbilities = () => restApi.get<GetAbilitiesData>(`${PATH}/abilities/v1`);
